import { render, staticRenderFns } from "./PromoteMember.vue?vue&type=template&id=6e7e07e4"
import script from "./PromoteMember.vue?vue&type=script&lang=js"
export * from "./PromoteMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports